import styled from 'styled-components';

export const CardTag = styled.article`
  position: relative;
  
  display: flex;
  align-items: flex-end;
  height: 100%;
  padding: 20px 25px;
  
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
`;

export const CardImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  
  width: 100%;
  height: 100%;
  
  pointer-events: none;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  &::after {
    content: "";
    
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    
    width: 110%;
    height: 100%;
    
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(255, 255, 255, 0.0001) 50%);
  }
`;

export const CardContainer = styled.div`
  position: relative;
  z-index: 1;
  
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  
  color: ${({ theme, textColor }) => textColor === 'white' ? theme.white : theme.black};
`;

export const CardHeading = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 20px;
  line-height: 25px;
  
  @media(min-width: 700px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

export const CardPrice = styled.p`
  margin: 0;
  padding: 0;
  
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  
  span {
    font-size: 18px;
  }
  
  @media(min-width: 700px) {
    span {
      font-size: 24px;
    }
  }
`;
